
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  label?: string;
  onClick?: () => void;
}

interface DetailPageTemplateProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  backButtonProps?: BackButtonProps;
}

const DetailPageTemplate = ({ 
  title, 
  description, 
  children, 
  backButtonProps 
}: DetailPageTemplateProps) => {
  const navigate = useNavigate();
  
  const handleBackClick = () => {
    if (backButtonProps?.onClick) {
      backButtonProps.onClick();
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleBackClick}
          className="flex items-center self-start"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          <span className="sm:inline hidden">{backButtonProps?.label || "Terug naar dashboard"}</span>
          <span className="sm:hidden">Terug</span>
        </Button>
        <div>
          <h1 className="text-lg sm:text-2xl font-bold">{title}</h1>
          {description && <p className="text-sm sm:text-base text-muted-foreground">{description}</p>}
        </div>
      </div>
      <div className="mt-2 sm:mt-4">
        {children}
      </div>
    </div>
  );
};

export default DetailPageTemplate;
